import { openapiGetapproval, getapprovaluser } from '@/port/clientSide/applicationRouting'
import { cloneDeep } from 'lodash'
import { momVal } from '@/api/utils'
import { getoherappvaldatalist } from "@/port/clientSide/oaExamineAudit";
import {
  getwebsiteapproval,
  getwebsiteapprovalreportdatalist
} from "@/port/pages/webSite"
// 固定画布下获取其他表的模板
export const getOtherAppConfig = async (canvasConfig, { isModify, isLook, orders, skey }) => {
  const appidList = getOtherAppId(canvasConfig)
  const resAppObj = {}
  if (appidList.length > 0) {
    const fn = skey ? getwebsiteapproval :openapiGetapproval
    const fn2 = skey ? getwebsiteapprovalreportdatalist : getoherappvaldatalist
    for (const id of appidList) {
      const query = { approvalId: id }
      if (skey) { query.skey = skey }
      const { code, data } = await fn(query)
      if (code === 0) {
        // 流程相关
        let property = JSON.parse(data.property)
        // 查看的时候所有控件都不能编辑
        if (isLook) {
          property = property.map(item => {
            item.per = 2
            return item
          })
        }
        let formdata = momVal(property, '');
        resAppObj[id] = {
          property,
        }
        if (isModify || isLook) {
          const query2 = {
            curpage: 0,
            pagesize: 1,
            type: 0,
            approvalId: id,
            query: { 'orders_orders': [orders] }
          }
          if (skey) { query2.skey = skey }
          const { code, data } = await fn2(query2)
          if (code === 0 && data.length > 0 && data[0].formdata) {
            const dataObj = data[0].formdata
            // 当前要修改这条数据的数据id
            resAppObj[id].approvingId = data[0].approvingId
            for(const key in formdata) {
              if (dataObj[key] !== undefined) {
                formdata[key] = dataObj[key] === 0 ? dataObj[key] : dataObj[key]
              }
            }
          }
        } else {
          const approvaluserRes = await getapprovaluser({ approvalId: id })
          const { to, cto, install } = approvaluserRes.data
          resAppObj[id].to = to
          resAppObj[id].cto = cto
          resAppObj[id].install = install
        }
        // 他表的数据
        resAppObj[id].formdata = formdata
      }
    }
  }
  return resAppObj
}

// 判断是否存在其他表的设置
export const getOtherAppId = (canvasConfig) => {
  const otherAppId = []
  if (canvasConfig.dataSource.formList && canvasConfig.dataSource.formList.length > 0) {
    const appids = canvasConfig.dataSource.formList.map(item => { return item.appid })
    canvasConfig.configList.forEach(item => {
      const appid = Number(item.fixedCanvasAppid)
      if (appids.includes(appid) && !otherAppId.includes(appid)) {
        otherAppId.push(appid)
      }
    })
  }
  return otherAppId
}

// 处理当前画布显示的模板
export const dealInputConfig = (config, property) => {
  const canvasConfig = cloneDeep(config)
  const resProperty = []
  // 把画布中用到的字段提出来
  canvasConfig.children.forEach((item) => {
    if (item.children) {
      item.children.forEach(iten => {
        const key = `${iten.title}_${iten.type}`
        const index = property.findIndex(iter => { return key === `${iter.title}_${iter.type}` })
        if (index !== -1) {
          const [field] = property.splice(index, 1)
          if (field) {
            field.row = index
            // field.col = 24 / colLen
            field.width = iten.w
            field.viewHide = false
            if (field.labelConfig === undefined) {
              field.labelConfig = {}
            }
            // 字段名显示
            field.labelConfig.isNameShow = iten.isShowKey ? true : false
            // 字段名样式
            field.labelConfig.fontKey = iten.fontKey
            field.layout = iten.Layout
            field.width = iten.w

            resProperty.push(field)

          }
        }
      })
    }
  })
  // 画布中没用到的字段隐藏 再添加进去
  property.forEach(item => {
    item.viewHide = true
  })
  resProperty.push(...property)
  return resProperty
}

// 设置字段的宽度
// const setCol = (width, colLen) => {
//   if (width > 120) {
//     return 24 / colLen
//   } else {
//     return Number((width / 100 * 24).toFixed(2))
//   }
// }

// 验证每个画布的数据
export const canvasDataVerify = (canvasConfig, InputAppInfo) => {
  let isPass = true
  let index = 0
  for(const canvasItem of canvasConfig) {
    index += 1
    const { formdata, property } = InputAppInfo[canvasItem.fixedCanvasAppid]
    const canvasFiled = [] // 画布中所有的字段
    canvasItem.children.forEach((item) => {
      if (item.children) { canvasFiled.push(...item.children) }
    })
    for(const item of canvasFiled) {
      const key = `${item.title}_${item.type}`
      const index = property.findIndex(iter => { return key === `${iter.title}_${iter.type}` })
      if (index !== -1) {
        const field = property[index]
        // 必填没填
        let val = formdata[key]
        if (field.type === 'richTextWid' && val) {
          val = val.replace(/<[^>]+>/g, '')
        }
        if (field.required === 'required' && ( (!val && val !== 0 ) || (Array.isArray(val) && val.length === 0) )) {
          isPass = false
          break
        }
      }
    }
    // 当前画布存在验证错误的数据
    if (!isPass) {
      break
    }
  }
  return { isPass, errorIndex: index }
}

// 验证当前画布数据是否填完
export const canvasDataIsFull = (canvasItem, InputAppInfo, type = 'isComplete') => {
  let isFull = true
  if (!InputAppInfo[canvasItem.fixedCanvasAppid]) return false
  const { formdata, property } = InputAppInfo[canvasItem.fixedCanvasAppid]
  const canvasFiled = [] // 画布中所有的字段
  canvasItem.children.forEach((item) => {
    if (item.children) { canvasFiled.push(...item.children) }
  })
  for(const item of canvasFiled) {
    const key = `${item.title}_${item.type}`
    const index = property.findIndex(iter => { return key === `${iter.title}_${iter.type}` })
    if (index !== -1) {
      const field = property[index]
      let val = formdata[key]
      if (field.type === 'richTextWid' && val) {
        val = val.replace(/<[^>]+>/g, '')
      }
      if (type === 'isRequired') {
        // 必填是否填完的判断
        if (field.required === 'required' && (!val && val !== 0) || (Array.isArray(val) && val.length === 0)) {
          isFull = false
          break
        }
      } else {
        // 是否填完的判断
        const isComplete = (!val && val !== 0) || (Array.isArray(val) && val.length === 0)
        if (isComplete) {
          isFull = false
          break
        }
      }

    }
  }
  return isFull
}



// 获取数据源提交配置
export const getOhterSubmitData = (customInputConfig, inputAppInfo, isModify) => {
  const formList = customInputConfig.dataSource && customInputConfig.dataSource.formList
  const dataList = []
  formList.forEach(item => {
    if (inputAppInfo[item.appid]) {
      const data = inputAppInfo[item.appid]

      let obj = {
        approvalId: item.appid,
        ...data.formdata,
      }
      if (isModify) {
        obj.approvingId = data.approvingId
      } else {
        obj = {
          cto: JSON.stringify(data.cto),
          to: JSON.stringify(data.to),
          install: JSON.stringify(data.install),
          linkedMessage: JSON.stringify([]),
          ...obj
        }
      }
      dataList.push(obj)
    }
  })
  return dataList
}
